import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="0 0 275.7 275.7"
    style={{ width: "3em", height: "3em" }}
    {...props}
  >
    <path
      d="M216.526 18.632c-63.888.419-127.918-.003-191.723 2.78-4.82 26.817-6.803 59.67-3.554 89.133 2.797 42.646 2.839 85.83 7.134 128.173 27.046 12.783 64.078 8.33 95.181 14.864 33.867 5.523 69.994 4.058 104.873 8.312 16.492-1.5 36.819 7.193 51.428.362 10.008-29.477-10.278-60.016-14.196-90.822-13.87-46.38-25.428-93.951-41.592-139.323-41.796-2.043 17.475-6.922-7.55-13.48zm-22.494 9.69c-2.2 4.382-51.756-1.498-12.142-.3l6.973.114z"
      fill="#8c6d5a"
    />
    <path d="M218.174 21.121c-63.929.85-128.4.036-191.995 3.055 27.738 12.304 68.735-2.046 101.49 2.005 24.809-1.566 79.975 7.891 90.505-5.06zm.14 12.626c-1.242 30.034 13.71 69.154 18.904 102.432 2.561 39.915 29.41 71.453 40.898 106.604-5.552 16.669-3.8 31.66 5.336 7.967-7.325-37.814-30.386-70.585-33.432-109.619-7.703-35.43-15.609-70.926-26.084-105.55zm-192.898 2.38c-9.01 34.533-1.214 73.928-.912 110.099 4.612 23.777-.72 123.018 7.926 86.782-.275-39.825-4.55-79.426-4.594-119.215-5.5-25.652-.342-52.528-2.42-77.666z" />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/frag-axe.svg